import { takeEvery, put } from 'redux-saga/effects';
import { SEND_MAIL, GET_OTP, SEND_OTP, GET_NEW_OTP } from '../action';
import { sendmail, getotp, sendotp } from '../../service';

import ToastTopHelper from '../../../../utils/toast';

function* sendMail({params}) {
  const { success, data } = yield sendmail(params);
  if (success) {
    yield put({
      type: SEND_MAIL.SUCCESS,
      data: data,
    });
    ToastTopHelper.success(`Hệ thống đã gửi OTP đến mail ${params.email}`);
  } else {
    yield put({
      type: SEND_MAIL.FAIL,
      data: data,
    });
  }
}

function* getOTP({params}) {
  const { success, data } = yield getotp(params);
  if (success) {
    yield put({
      type: GET_OTP.SUCCESS,
      data: data,
    });
    ToastTopHelper.success(`Hệ thống đã gửi OTP đến mail ${params.email}`);
  } else {
    yield put({
      type: GET_OTP.FAIL,
      data: data,
    });
  }
}

function* sendOTP({params}) {
  const { success, data } = yield sendotp(params);

  if (success) {
    yield put({
      type: SEND_OTP.SUCCESS,
      data: data,
    });
  } else {
    yield put({
      type: SEND_OTP.FAIL,
      data: data,
    });
  }
}

function* getNewOTP({params}) {
 
  yield put({
    type: SEND_MAIL.REQUEST,
    params: params,
  });
}

export default function* () {
  yield takeEvery(SEND_MAIL.REQUEST, sendMail);
  yield takeEvery(GET_OTP.REQUEST, getOTP);
  yield takeEvery(SEND_OTP.REQUEST, sendOTP);
  yield takeEvery(GET_NEW_OTP, getNewOTP);
}
